import { render, staticRenderFns } from "./LandingProducts.vue?vue&type=template&id=dd9fa668"
import script from "./LandingProducts.vue?vue&type=script&lang=js"
export * from "./LandingProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports